import placeholder3D from "@/assets/img/placeholders/placeholder_3d.svg";
import audio from "@/assets/img/placeholders/placeholder_audio.svg";
import image from "@/assets/img/placeholders/placeholder_image.svg";
import video from "@/assets/img/placeholders/placeholder_video.svg";
import pdf from "@/assets/img/placeholders/placeholder_pdf.svg";
import article from "@/assets/img/placeholders/placeholder_article.svg";
import mosaic from "@/assets/img/placeholders/placeholder_mosaic.svg";
import imagemap from "@/assets/img/placeholders/placeholder_imagemap.svg";
import gallery from "@/assets/img/placeholders/placeholder_gallery.svg";
import timeline from "@/assets/img/placeholders/placeholder_timeline.svg";
import flipbook from "@/assets/img/placeholders/placeholder_flipbook.svg";
import autoplay from "@/assets/img/placeholders/placeholder_autoplay.svg";
import kioskIpad from "@/assets/img/placeholders/placeholder_kiosk_ipad.svg";
import kioskWindows from "@/assets/img/placeholders/placeholder_kiosk_windows.svg";

import type { Document } from "@/declarations/models/Document";
import type { Media } from "@/declarations/models/Media";
import MediaType from "@/declarations/models/MediaType";

const mediaTypePlaceholderMap: { [mt in MediaType]: string | undefined } = {
  [MediaType.IMAGE]: "image",
  [MediaType.AUDIO]: "audio",
  [MediaType.VIDEO]: "video",
  [MediaType.DOCUMENT]: "pdf",
  [MediaType.YOUTUBE]: "video",
  [MediaType.VIMEO]: "video",
  [MediaType.SKETCHFAB]: "3d",
  [MediaType.DM]: "image",
  [MediaType.MODEL_3D]: "3d",
};

export function getPlaceholderMediaImage(item: Media) {
  let type = mediaTypePlaceholderMap[item.media_type] ?? "";
  return getPlaceholderImage(type);
}

export function getPlaceholderDocumentImage(item: Document) {
  let type = "";
  switch (item?.schema_slug) {
    case "kp.article":
      type = "article";
      break;
    case "kp.kiosk.view":
      type = item?.content?.general?.presentationType?.toLowerCase() ?? "";
      break;
    case "kp.kiosk.device":
      type = item?.content?.device?.deviceType?.toLowerCase() ?? "";
      break;
    default:
      type = "";
      break;
  }
  return getPlaceholderImage(type);
}
export function getPlaceholderImage(type: string) {
  switch (type) {
    case "mosaic":
      return mosaic;
    case "imagemap":
      return imagemap;
    case "gallery":
      return gallery;
    case "timeline":
      return timeline;
    case "flipbook":
      return flipbook;
    case "audio":
      return audio;
    case "video":
      return video;
    case "image":
      return image;
    case "pdf":
      return pdf;
    case "article":
    case "single":
      return article;
    case "3d":
      return placeholder3D;
    case "autoplay":
      return autoplay;
    case "ipad":
      return kioskIpad;
    case "windows":
      return kioskWindows;
    default:
      return "";
  }
}
